import {useEffect} from 'react'
import { init }  from '@amplitude/analytics-browser'
import { amplitudeDev, amplitudeProd} from '@helpers/events/config'
import {setBasicProperties} from '@helpers/posthog'
import { posthogProd, urlPosthogProd} from '@helpers/posthog/config'
import useWebsiteId from '@hooks/useWebsiteId'
import getEnv from '@providers/getEnv'
import {useRouter} from 'next/router'
import posthog from 'posthog-js'

export default function usePosthog() {
  const router = useRouter()
  const websiteId = useWebsiteId()
  useEffect(() => {
    const amplitudeApiKey = getEnv() === 'prod' ? amplitudeProd : amplitudeDev
    // Init amplitude
    init(amplitudeApiKey) 
    if(getEnv() !== 'prod'){
      return null
    }
    // Init PostHog
    posthog.init(posthogProd, {
      api_host: urlPosthogProd,
      autocapture: false
    })

    posthog.clear_opt_in_out_capturing()
    setBasicProperties({websiteId})

    // Track page views
    const handleRouteChange = () => posthog.capture('$pageview')
    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [])
  return null
}

export const WithPosthog = ({children}) => {
  usePosthog()
  return children
}
